<template>
      <div class="xs-12 p4">
            <!-- Headlines -->
            <div class="flex x-12 xs-middle">
                  <p class="flex xs-6 xs-left fw7">{{$t("select_client")}}</p>
                  <div class="flex xs-6 xs-right">
                        <router-link :to="`/${$route.params.tenantId}/clients/create`">
                              <j-button type="tertiary">
                                    <crm-icon name="add" size="small" color="c2"/>
                                    {{ $t("or_create_new_client") }}
                              </j-button>
                        </router-link>
                  </div>
            </div>

            <!-- Select Client -->
            <core-select-client
                  class="mt1"
                  v-model="selectedClient"
                  :clientType="clientType"
                  @input="fetchClient()"
                  @clientTypeChange="clientType = $event"
            ></core-select-client>

            <!-- Selected Client(s) -->
            <core-individual-card
                  v-if="clientType === 'individual' && selectedClient.length !== 0 "
                  class="mt6"
                  v-bind="fetchedClient"
                  :isExpandable="true"
            />
            <core-company-card
                  v-if="clientType === 'company' && selectedClient.length !== 0 "
                  class="mt6"
                  v-bind="fetchedClient"
                  :isExpandable="true"
            />

            <!-- Display when no selected client -->
            <j-card v-if="selectedClient.length === 0" class="p3 mt6 bg5">{{ $t("errors.no_data") }}</j-card>

            <!-- Buttons -->
            <div class="flex xs-between mt6">
                  <j-button :isLoading="isLoading" @click="handleSave">{{ $t("save") }}</j-button>
                  <j-button @click="handleCancel" type="bordered">{{ $t("cancel") }}</j-button>
            </div>
      </div>
</template>

<script>
import CoreSelectClient from "@/modules/core/components/CoreSelectClient"
import JButton from "@/components/JButton"
import JCard from "@/components/JCard"
import CrmIcon from "@/components/CrmIcon"
import CoreIndividualCard from "@/modules/core/components/CoreIndividualCard"
import CoreCompanyCard from "@/modules/core/components/CoreCompanyCard"
import api from "../api"

export default {
	props: {
		for: {
			Type: String,
			validator(val) {
				return (
					val === null ||
					[
						"change_holder",
						"add_holder",
						"add_insured"
					].includes(val)
				)
			}
		}
	},
	components: {
		CoreSelectClient,
		JButton,
		JCard,
		CrmIcon,
		CoreIndividualCard,
		CoreCompanyCard
	},
	data() {
		return {
			isLoading: false,
			selectedClient: [], // contains selected client id and name, mainly used for CoreSelectClient searching
			clientType: "individual",
			fetchedClient: {}
		}
	},
	methods: {
		async handleSave() {
			if (this.selectedClient.length === 0) return

			const policyId = this.$route.params.id
			const entityId = this.selectedClient[0].id

			if (this.for === "change_holder") {
				this.changeHolder(policyId, entityId)
			}

			if (this.for === "add_holder") {
				this.addOtherHolder(policyId, entityId)
			}

			if (this.for === "add_insured") {
				this.addInsured(policyId, entityId)
			}
		},

		handleCancel() {
			this.$emit("cancelled")
		},

		// use id from selectedClient to fetch client object,
		// used to fetch and display data in CoreIndividualCard and CoreCompanyCard
		async fetchClient() {
			if (this.selectedClient.length === 0) return

			const res = await api[this.clientType]({
				where: {
					id: this.selectedClient[0].id
				}
			})

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			if (this.clientType === "individual") {
				this.fetchedClient = res.data.individuals.list[0]
			} else this.fetchedClient = res.data.companies.list[0]
		},

		async changeHolder(policyId, entityId) {
			const updatePolicyInput = {
				holderId: entityId
			}

			this.isLoading = true

			const res = await api.updateQuote({
				policyId,
				updatedPolicy: updatePolicyInput
			})

			this.isLoading = false

			// // Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.$emit("saved")
		},

		async addInsured(policyId, entityId) {
			const res = await api.addInsured({
				policyId,
				entityId
			})

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.$emit("saved")
		},

		async addOtherHolder(policyId, entityId) {
			const res = await api.addOtherHolder({
				policyId,
				entityId
			})

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.$emit("saved")
		}
	}
}
</script>